import { LoadingScreen } from '@avanta/shared/components/LoadingScreen';
import { useNewConversationListener } from '@avanta/shared/hooks/chat/useNewConversationListener';
import { useConversationsStore } from '@avanta/shared/stores/chat/conversations';
import { useChatStore } from '@avanta/shared/stores/chat/index';
import { cn } from '@avanta/shared/utils/cn';
import { Conversation } from './Conversation';
import { useChatInitializer } from './hooks/useChatInitializer';

const ChatContent = (): React.ReactElement => {
  const isInitialized = useChatStore(state => state.isInitialized);
  const isLoadingConversations = useConversationsStore(state => state.isLoading);
  const isBootstrapping = !isInitialized || isLoadingConversations;

  if (isBootstrapping) {
    return <LoadingScreen />;
  }

  return (
    <div className="flex min-h-0 flex-1 flex-row">
      <Conversation />
    </div>
  );
};

export const Chat = (): React.ReactElement => {
  useChatInitializer();
  useNewConversationListener();
  return (
    <div className={cn('flex h-full flex-col mx-auto max-w-7xl pb-4')}>
      <ChatContent />
    </div>
  );
};
